import { render, staticRenderFns } from "./suporte-tipo-acomodacao.vue?vue&type=template&id=72429b38"
import script from "./suporte-tipo-acomodacao.vue?vue&type=script&lang=ts"
export * from "./suporte-tipo-acomodacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports